// Cognito 설정 - AWS Console에서 받은 값으로 변경 필요
const COGNITO_DOMAIN = process.env.REACT_APP_COGNITO_DOMAIN || 'https://skillparser-auth.auth.ap-northeast-2.amazoncognito.com';
const CLIENT_ID = process.env.REACT_APP_COGNITO_CLIENT_ID || 'your-client-id-here';
const REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI || 'https://skillparser.hcg-hr-labs.com';

export const login = () => {
  const loginUrl = `${COGNITO_DOMAIN}/login?client_id=${CLIENT_ID}&response_type=token&scope=openid+email+profile&redirect_uri=${encodeURIComponent(REDIRECT_URI)}`;
  window.location.href = loginUrl;
};

export const logout = () => {
  localStorage.removeItem('access_token');
  localStorage.removeItem('id_token');
  const logoutUrl = `${COGNITO_DOMAIN}/logout?client_id=${CLIENT_ID}&logout_uri=${encodeURIComponent(REDIRECT_URI)}`;
  window.location.href = logoutUrl;
};

export const handleCallback = () => {
  // URL hash에서 토큰 추출
  const hash = window.location.hash.substring(1);
  const params = new URLSearchParams(hash);

  const accessToken = params.get('access_token');
  const idToken = params.get('id_token');

  if (accessToken && idToken) {
    localStorage.setItem('access_token', accessToken);
    localStorage.setItem('id_token', idToken);

    // URL에서 hash 제거
    window.history.replaceState({}, document.title, window.location.pathname);

    return true;
  }

  return false;
};

export const getToken = () => {
  return localStorage.getItem('access_token');
};

export const isAuthenticated = () => {
  const token = getToken();
  if (!token) return false;

  // 토큰 만료 체크 (선택사항)
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const expirationTime = payload.exp * 1000;

    if (Date.now() >= expirationTime) {
      logout();
      return false;
    }

    return true;
  } catch (e) {
    return false;
  }
};

export const getUserInfo = () => {
  const idToken = localStorage.getItem('id_token');
  if (!idToken) return null;

  try {
    const payload = JSON.parse(atob(idToken.split('.')[1]));
    return {
      email: payload.email,
      name: payload.name || payload.email,
    };
  } catch (e) {
    return null;
  }
};

export const getUserGroups = () => {
  const idToken = localStorage.getItem('id_token');
  if (!idToken) return [];
  try {
    const payload = JSON.parse(atob(idToken.split('.')[1]));
    return payload['cognito:groups'] || [];
  } catch (e) {
    return [];
  }
};
